<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5SfLGr/tc-custom/9781497619173.jpg?1734636257810" alt="This image is the cover for the book Reilly's Woman, The Americana Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Reilly's Woman, The Americana Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Love and danger collide as the cross-country romance series heads to Nevada—from the bestselling author with more than 300 million books in print. </b><br/><br/> The crash of a Cessna 310 charter flight on a Nevada mountainside has left two survivors: Leah Talbot, a young secretary from Las Vegas, and the pilot, lone wolf Reilly Smith. Part Native American, all man, Reilly is impassive, mysterious, and inscrutable. Under the noonday sun, they make their way across a hostile stretch of Nevada desert. Under the cold night rain, they have only their bodies, locked in embrace, to keep them warm.<br/>  <br/> As two desperate strangers come together, so does a desire that burns as hot as the sand. But Reilly’s instincts are as strong as his survival skills. They may share a love that’s helping to keep them alive, but he knows that once they reach civilization the bond between them will be severed with a last kiss goodbye. Unless Reilly can make Leah realize that she’s saved him as much as he’s saved her.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Dailey
      </h2>
      
      <p class="authorDescription body article">Janet Dailey, who passed away in 2013, was born Janet Haradon in 1944 in Storm Lake, Iowa. She attended secretarial school in Omaha, Nebraska, before meeting her husband, Bill. The two worked together in construction and land development until they &ldquo;retired&rdquo; to travel throughout the United States, inspiring Dailey to write the Americana series of romances, setting a novel in every state of the Union. In 1974, Dailey was the first American author to write for Harlequin. Her first novel was <I>No Quarter Asked</I>. She went&#160;on to write approximately ninety novels, twenty-one of which appeared on the <I>New York Times</I> bestseller list. She won many awards and accolades for her work, appearing widely on radio and television. Today, there are over three hundred million Janet Dailey books in print in nineteen different languages, making her one of the most popular novelists in the world. For more information about Dailey, visit www.janetdailey.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?402c4fea